import { intlFormatDistance } from 'date-fns';

export function formatDateDistance(date: number | Date) {
  return intlFormatDistance(date, Date.now(), {
    locale: 'ja',
    numeric: 'always',
  }).replace(' ', '');
}
